var _g, _path, _path2, _g2, _path3, _g3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceFileDelete = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 58,
  height: 58,
  viewBox: "0 0 58 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#tyluoelt5a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44 9H14a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4z",
  fill: "#0D3474"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44 9H14a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4z",
  fill: "#0D3474"
})), /*#__PURE__*/React.createElement("mask", {
  id: "px6a60zpqb",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 20,
  y: 20,
  width: 19,
  height: 19
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m34.454 36.2-.03.13c-.129.428-.618.757-1.214.757h-7.897l-.175-.01c-.574-.063-1.013-.432-1.069-.877l-2.5-15.696-1.527.166 2.5 15.697.04.215c.26 1.13 1.404 1.94 2.731 1.94h7.897l.246-.009c1.3-.1 2.378-.978 2.523-2.146l2.5-15.697-1.526-.166-2.5 15.696z",
  fill: "#fff"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#px6a60zpqb)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m34.454 36.2-.03.13c-.129.428-.618.757-1.214.757h-7.897l-.175-.01c-.574-.063-1.013-.432-1.069-.877l-2.5-15.696-1.527.166 2.5 15.697.04.215c.26 1.13 1.404 1.94 2.731 1.94h7.897l.246-.009c1.3-.1 2.378-.978 2.523-2.146l2.5-15.697-1.526-.166-2.5 15.696z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.357 45.696h33.81V13.33h-33.81v32.366z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "xhxjnb4nmc",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 25,
  y: 17,
  width: 8,
  height: 4
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m27.173 17-.19.01c-1.007.103-1.731 1.012-1.731 2.055v1.522h1.537v-1.522l.009-.137c.045-.301.226-.493.375-.493h3.843l.065.011c.155.055.32.287.32.619v1.522h1.537v-1.522l-.008-.194C32.841 17.847 32.056 17 31.016 17h-3.843z",
  fill: "#fff"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#xhxjnb4nmc)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m27.173 17-.19.01c-1.007.103-1.731 1.012-1.731 2.055v1.522h1.537v-1.522l.009-.137c.045-.301.226-.493.375-.493h3.843l.065.011c.155.055.32.287.32.619v1.522h1.537v-1.522l-.008-.194C32.841 17.847 32.056 17 31.016 17h-3.843z",
  fill: "#fff"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.093 21.304h20.005v-1.436H19.093v1.436zM30.03 34.138l1.528.16 1.537-10.046-1.528-.158-1.537 10.044zM25.418 24.253l1.538 10.043 1.528-.157-1.538-10.045-1.528.159z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "tyluoelt5a",
  x: 0,
  y: 0,
  width: 58,
  height: 58,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.054902 0 0 0 0 0.203922 0 0 0 0 0.454902 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_255_4118"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_255_4118",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceFileDelete);
export default ForwardRef;